module.exports = {
  title: 'PAITEAMS',
  def_logo_url:process.env.VUE_APP_DOMAIN === 'paiteams.com'?'https://osspub.paiteams.com/pub-paiteams/logo-full.png':'https://puboss.paiteams.cn/common/20260811/logo-full.png',
  def_line_logo_url:process.env.VUE_APP_DOMAIN === 'paiteams.com'?'https://osspub.paiteams.com/pub-paiteams/logo.png':'https://puboss.paiteams.cn/common/20260811/logo.png',
  ossBucketFlags: {
    private: ['pr-paiteams', 'pr-xunmazhe','pri-paiteams'],
    def: ['pub-paiteams', 'xunmazhe','pub-cnpaiteams']
  },
  // 标题分隔符
  titleSeparator: ' - ',
  // 标题是否反转 如果为false:"page - title"，如果为ture:"title - page"
  titleReverse: false,
  routesWhiteList: [
    '/login',
    '/mobile/mobile-login',
    '/forget',
    '/google_auth/:google_code?',
    '/join-team/:invite_code',
    '/invitation/:code',
    '/home',
    '/web-generation',
    '/image-generation',
    '/404',
    '/chat-share/:share_code',
    '/web_preview/:ver_uuid',
    '/pdf-print/:doc_uniq_code'
  ],
  notPopUrlList: [
    '/api/chat/agent-send-message',
    '/api/knowledge/agent-send-message',
    '/api/agent/counselor-optimize',
    '/api/agent/set-com-agent-chat-status',
    '/api/i18n/resource-locale',
    '/api/knowledge/save-online-doc',
    '/api/media-canvas/save',
    '/api/socket/report-client-diagnostic'
  ],
  defUrlList:[
    '/api/user/login'
  ]
}
